import { FAQData } from '../components/faq/faqTypes';
import localFaqData from '../components/faq/faqData.json';

import { GOOGLE_API_KEY } from './constants';

// Using Google Drive API v3 endpoint
declare const process: {
  env: {
    REACT_APP_GOOGLE_DRIVE_API_KEY: string | undefined;
  };
};

const GOOGLE_DRIVE_API_KEY = 'AIzaSyCoOBoxdyl5-4sHLdNr_Z8a0SrEsSqqu_s';

export async function fetchFAQData(driveFileId: string): Promise<FAQData> {
  try {
    if (!GOOGLE_API_KEY) {
      console.info('🔑 No API key found, using local data');
      return localFaqData as FAQData;
    }

    // Create AbortController for timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000); // 3 second timeout

    const response = await fetch(
      `https://www.googleapis.com/drive/v3/files/${driveFileId}?alt=media&key=${GOOGLE_API_KEY}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
        signal: controller.signal,
      }
    );

    clearTimeout(timeoutId); // Clear timeout if request completes

    if (!response.ok) {
      console.error('🚨 Google Drive API Error:', {
        status: response.status,
        statusText: response.statusText,
        url: response.url,
      });
      return localFaqData as FAQData;
    }

    const data = await response.json();
    return data as FAQData;
  } catch (error) {
    console.error('🔥 Failed to fetch FAQ data:', {
      error,
      fallback: 'Using local data',
    });
    return localFaqData as FAQData;
  }
}
